<script lang="ts">

  import type UpsellingAlternative from '../api/UpsellingAlternative';
  import { getAlternative } from '../api/getAlternative';
  import OnexC from './OnexC.svelte';
  import OnexA from './OnexA.svelte';
  import OnexE3534Group from '../api/OnexE3534Group';
  import Onex3534Group from '../api/OnexE3534Group';
  import tracker from '../tracking/Tracker';
  import type UpsellingComponentProps from './UpsellingComponentProps';

  const PDP_UPSELLING_SLOT_ID = 'pdp_upselling__slot';

  let { variationId, onexE3534Group }: UpsellingComponentProps = $props();
  let data = $state<UpsellingAlternative | undefined>();

  $effect(() => {
    if (!variationId) {
      return;
    }

    getAlternative(variationId).then((upsellingAlternative) => {
      data = upsellingAlternative;
      if (data) {
        if (data.onexE3534Group === OnexE3534Group.PLAIN || data.onexE3534Group === Onex3534Group.DETAILED) {
          const pdpUpsellingSlot = document.getElementById(PDP_UPSELLING_SLOT_ID);
          pdpUpsellingSlot?.classList.remove('pl_hidden');
        }
        tracker.addToPageImpression({ product_Upselling: 'available' });
      }
    });
  });

  let finalOnexE3534Group = $derived<OnexE3534Group | undefined>(onexE3534Group || data?.onexE3534Group);
</script>

{#if variationId && data}
    <div class='ft5_upselling-service--survey' style="display: none"></div>
    {#if finalOnexE3534Group && data.onexE3534Group !== OnexE3534Group.STATUS_QUO}
        {#if finalOnexE3534Group === OnexE3534Group.PLAIN}
            <OnexA
                variationId={variationId}
                imageAltText={data.imageAltText}
                imageUrl={data.imageUrl}
                variationsComparisonHeading={data.variationsComparisonHeading}
                variationsComparisonCaption={data.variationsComparisonCaption}
                variationUrl={data.variationUrl}
            />
        {/if}
        {#if [OnexE3534Group.DETAILED, OnexE3534Group.DETAILED_ANIMATED_DEV].includes(finalOnexE3534Group)}
            <OnexC
                variationId={variationId}
                animated={finalOnexE3534Group === OnexE3534Group.DETAILED_ANIMATED_DEV}
                brandName={data.brandName}
                name={data.name}
                imageAltText={data.imageAltText}
                imageUrl={data.imageUrl}
                variationsComparisonHeading={data.variationsComparisonHeading}
                variationsComparisonCaption={data.variationsComparisonCaption}
                retailPrice={data.retailPrice}
                suggestedRetailPrice={data.suggestedRetailPrice}
                normPrice={data.normPrice}
                normUnit={data.normUnit}
                variationUrl={data.variationUrl}
                averageRatingRounded={data.averageRatingRounded}
                numberOfReviews={data.numberOfReviews}
                energyEfficiencyClass={data.energyEfficiencyClass}
                energyEfficiencyColor={data.energyEfficiencyColor}
                energyEfficiencyLabelVersion={data.energyEfficiencyUniform ? 'uniform' : 'default'}
            />
        {/if}
    {/if}
{/if}
